export default "__VITE_ASSET__be3f033c__"